<div class="flex flex-row">
    <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="add-tenant mt-20 ml-24 mr-48 mb-24 flex fs-24 fw-600">
    <img  class=" ml-20 icon mr-12 mt-24 mb-28" src="/assets/icons/add-tenant-icon.svg">
   <div class="flex flex-col">
    <div class="flex flex-row"><span class="flex flex-row" [ngClass]="isEdit ? 'mt-16' : 'mt-24'">  {{ isEdit ? ('ADD_TENANT.EDIT_TENANT' | transloco) : ('TENANT_FORM.NAME' | transloco) }}  </span></div>
   <div class="flex flex-row"><span class="fw-400 fs-14">  {{ isEdit ? (editTenantData.tenantId ): '' }}  </span></div>
  </div>
  </div>
<div class="pl-24 pb-20 pr-48 schedule-container">
    <div class="flex ml-24">
        <div class="flex items-center">
            <div class="flex flex-col" [ngClass]="{'current-tab': currentStep === 1, 'not-visited': !visitedSteps.stepOne}">
                <div class="flex flex-row ml-30">
                    <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="visitedSteps.stepOne && currentStep !== 1" svgIcon="done" class="color-done"></mat-icon></span></span>
                    <span class="horizontal-line mr-12"></span>
                </div>
                <span class="mat-subtitle-2 fw-500 tab-name">{{'ADD_TENANT.FOUNDATION_DETAILS' | transloco}}</span>

            </div>
            <div class="flex flex-col" [ngClass]="{'current-tab': currentStep === 2, 'not-visited': !visitedSteps.stepTwo}">
                <div class="flex flex-row">
                    <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="visitedSteps.stepTwo && currentStep !== 2" svgIcon="done" class="color-done"></mat-icon></span></span>
                    <span class="horizontal-line mr-12"></span>
                </div>
                <span class="mat-subtitle-2 fw-500 tab-name ml--26">{{'ADD_TENANT.CLOUD_REGION' | transloco}}</span>
            </div>
            <div class="flex flex-col" [ngClass]="{'current-tab': currentStep === 3, 'not-visited': !visitedSteps.stepThree}">
                <div class="flex flex-row">
                    <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="visitedSteps.stepThree && currentStep !== 3" svgIcon="done" class="color-done"></mat-icon></span></span>
                    <span class="horizontal-line mr-12"></span>
                </div>
                <span class="mat-subtitle-2 fw-500 tab-name ml--52">{{'ADD_TENANT.CUSTOMER_INFORMATION' | transloco}}</span>
            </div>
            <div class="flex flex-col" [ngClass]="{'current-tab': currentStep === 4, 'not-visited': !visitedSteps.stepFour}">
                <div class="flex flex-row">
                    <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="visitedSteps.stepFour && currentStep !== 4" svgIcon="done" class="color-done"></mat-icon></span></span>
                    <span class="horizontal-line mr-12"></span>
                </div>
                <span class="mat-subtitle-2 fw-500 tab-name ml--12">{{'ADD_TENANT.FEATURES' | transloco}}</span>
            </div>
            <div class="flex flex-col" [ngClass]="{'current-tab': currentStep === 5, 'not-visited': !visitedSteps.stepFive}">
                <div class="flex flex-row">
                    <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="visitedSteps.stepFour && currentStep !== 4" svgIcon="done" class="color-done"></mat-icon></span></span>
                    <span class="horizontal-line mr-12"></span>
                </div>
                <span class="mat-subtitle-2 fw-500 tab-name ml--12">{{'ADD_TENANT.SETTINGS' | transloco}}</span>
            </div>
            <div class="flex flex-col" [ngClass]="{'current-tab': currentStep === 6, 'not-visited': !visitedSteps.stepSix}">
                <div class="flex flex-row">
                    <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="visitedSteps.stepFour && currentStep !== 4" svgIcon="done" class="color-done"></mat-icon></span></span>
                </div>
                <span class="mat-subtitle-2 fw-500 tab-name ml--12">{{'ADD_TENANT.SUMMARY' | transloco}}</span>
            </div>
        </div>
    </div>

    <!---Foundation Details step 1-->
     <div [formGroup]="detailsForm" *ngIf="currentStep === 1" class="environment_header min-h-[400px] mt-24">
        <div class="flex flex-row ml-24 mt-24">
            <div class="flex flex-col form-field name-field">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.REALM_NAME' | transloco | uppercase }}</label>
                </div>
                <input formControlName="tenantId" class="blend-border mt-4" [ngClass]="{ 'input-disabled': isEdit }"
                [placeholder]="'TENANT_FORM.FOUNDATION_REALM_NAME' | transloco">
                  <app-error [control]="detailsForm?.get('tenantId')"></app-error>
            </div>

            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.IT_TICKETNUMBER' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.IT_TICKETNUMBER' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <input formControlName="ticketNumber" class="blend-border mt-4" [ngClass]="{ 'input-disabled': isEdit }"
                [placeholder]="'INSTANCE_DETAILS.ENTER_TICKET_NUMBER' | transloco">
                  <app-error [control]="detailsForm?.get('ticketNumber')"></app-error>
            </div>

            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12 mb-4">{{ 'TENANT_FORM.CUSTOMER_STATUS' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CUSTOMER_STATUS' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <div>
                    <mat-select formControlName="status" [ngClass]="{ 'input-disabled': !isEdit }" class="blend-border drop-down pt-4" >
                        <mat-option *ngFor="let tag of numbers" [value]="tag">{{ tag }}</mat-option>
                    </mat-select>
                </div>
                  <app-error [control]="detailsForm?.get('status')"></app-error>
            </div>

            <div class="flex flex-col form-field name-field ml-24 mr-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.TENANT_OWNER' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.TENANT_OWNER' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <input formControlName="tenantOwner" class="blend-border mt-4"
                [placeholder]="'ADD_TENANT.ENTER_EMAIL_ADDRESS' | transloco">
                  <app-error [control]="detailsForm?.get('tenantOwner')"></app-error>
                  <div *ngIf="detailsForm.get('tenantOwner')?.errors?.['pattern']">
                    <span class="amber_color mt-8">{{ 'ADD_TENANT.EMAIL_VALIDATION' | transloco }}</span>
                  </div>
            </div>



        </div>
    </div>

<!--Cloud Region step 2-->
    <div [formGroup]="cloudRegionForm" *ngIf="currentStep === 2" class="environment_header min-h-[400px] mt-24">
        <div class="flex flex-row ml-24 mt-24">
            <div class="flex flex-col form-field name-field">
                <div class="flex flex-row mb-8 flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'INSTRUCTION.CREATE_INSTRUCTION.CLOUD_PROVIDER' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'INSTRUCTION.CREATE_INSTRUCTION.CLOUD_PROVIDER' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <mat-select formControlName="cloudProvider" [ngClass]="{ 'input-disabled': isEdit }" class="blend-border drop-down mt-4 pt-4" (selectionChange)="onSelectionChange($event)" [placeholder]="'INSTANCE_DETAILS.CHOOSE' | transloco">
                    <mat-option *ngFor="let region of cloudRegion" [value]="region">{{ region }}</mat-option>
                </mat-select>
                  <app-error [control]="cloudRegionForm?.get('cloudProvider')"></app-error>
            </div>
        </div>

        <div *ngIf="cloudProvider" class="flex flex-row name-field mt-8">
         <div class="flex flex-col flex-wrap">
            <div  class="flex flex-col ml-24 mb-2">
                <div class="flex flex-row">
                    <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.CHOOSE_REGION' | transloco | uppercase }}</label>
                    <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CHOOSE_REGION' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                  </div>
            </div>
            <div class="flex flex-row">
              <ng-container *ngFor="let option of regions">
                <div class="flex flex-col flex-wrap ml-24" [ngClass]="{'hide-region-pair': cloudProvider === 'AWS' && option.value === 'Region Pair', 'move-left': cloudProvider === 'AWS' && option.value === 'Custom Region' }">
                  <div class="flex flex-row  cursor-pointer p-6" [ngClass]="{ 'radio-disabled': isEdit && prodEdgeNetworkDeployed}"
                  (click)="isEdit && prodEdgeNetworkDeployed ? null : selectRegion(option)">
                    <mat-icon *ngIf="selectedRegion === option" svgIcon="radio_button_checked" class="radio-icon cursor-pointer"  [ngClass]="{ 'disabled': isEdit && prodEdgeNetworkDeployed}"></mat-icon>
                    <mat-icon *ngIf="selectedRegion !== option" svgIcon="radio_button_unchecked" class="radio-icon disabled-icon"  [ngClass]="{ 'disabled': isEdit && prodEdgeNetworkDeployed}"></mat-icon>
                    <span class="mat-body-1 fw-500 ml-6 mr-24 mb-0 primary-fg">
                      {{ option.label }}
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="flex flex-row w-100-percent ml-24 mt-24 mb-8">
              <div *ngIf="isRegionPairSelected && cloudProvider!== 'AWS'" class="flex flex-col mr-24">
                <div class="flex flex-row">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.CHOOSE_REGION_PAIR' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8 mt-4" [matTooltip]="'TENANT_FORM.CHOOSE_REGION_PAIR' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <div class="provider-dropdown">
                  <mat-select formControlName="regionPair" [ngClass]="{ 'input-disabled': isEdit }" class="blend-border drop-down mt-8 pt-4" placeholder="Choose region" (selectionChange)="!isEdit ? onRegionPairChange($event) :''">
                    <mat-option *ngFor="let region of azureRegionPairs" [value]="region?.name" >{{ region?.displayName }}</mat-option>
                  </mat-select>
                  <app-error [control]="cloudRegionForm?.get('regionPair')"></app-error>
                </div>
              </div>
              <div class="flex flex-col mr-24">
                <div class="flex flex-row">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.PRIMARY_REGION' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8 mt-4" [matTooltip]="'TENANT_FORM.PRIMARY_REGION' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <div class="provider-dropdown">
                  <mat-select [disabled]="!primaryRegion?.length" formControlName="primaryRegion" class="blend-border drop-down mt-8 pt-4" [ngClass]="{'input-disabled disable-selection': isEdit || selectedRegion?.value === 'Region Pair'}" placeholder="Choose primary region" (selectionChange)="!isEdit? onPrimaryRegionChange($event) :''">
                    <mat-option *ngFor="let region of primaryRegion" [value]="region?.name || region" >{{ region?.displayName || region }}</mat-option>
                    <mat-option *ngIf="!primaryRegion?.length" disabled>{{ 'TENANT_FORM.NO_REGION_FOUND' | transloco }}</mat-option>
                  </mat-select>
                  <app-error [control]="cloudRegionForm?.get('primaryRegion')"></app-error>
                </div>
              </div>
              <div class="flex flex-col mr-24" *ngIf="!singleRegionSelected">
                <div class="flex flex-row">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.SECONDARY_REGION' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8 mt-4" [matTooltip]="'TENANT_FORM.SECONDARY_REGION' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <div class="provider-dropdown">
                  <mat-select [disabled]="!secondaryRegion?.length" formControlName="secondaryRegion" class="blend-border drop-down mt-8 pt-4" [ngClass]="{ 'input-disabled disable-selection': (isEdit && prodEdgeNetworkDeployed) || selectedRegion?.value === 'Region Pair'}" placeholder="Choose secondary region" (selectionChange)="!isEdit? onSecondaryRegionChange($event):''">
                    <mat-option *ngFor="let region of secondaryRegion" [value]="region?.name || region" [disabled]="(region?.name || region) === cloudRegionForm.get('primaryRegion')?.value">{{ region?.displayName || region }}</mat-option>
                    <mat-option *ngIf="!secondaryRegion?.length" disabled>{{ 'TENANT_FORM.NO_REGION_FOUND' | transloco }}</mat-option>
                </mat-select>
                  <app-error [control]="cloudRegionForm?.get('secondaryRegion')"></app-error>
                </div>
              </div>
            </div>
            <ng-container>
              <div class="flex flex-col ml-24 mt-8 disabled">
              <div class="flex flex-row mat-subtitle-2 fw-500">
                <label class="fw-700 fs-12" >{{'TENANT_FORM.SECONDARY_DEPLOYMENT' | transloco | uppercase}}</label>
                <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.SECONDARY_DEPLOYMENT' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
              </div>
              <div class="flex flex-row mt-10 mb-16 mat-subtitle-2 fw-500 w-fit" [ngClass]="{ 'radio-disabled': isEdit  && prodEdgeNetworkDeployed}">
                <div *ngFor="let option of hasSecondary" class="flex flex-row mr-32" [ngClass]="{ 'secondary-disabled': isEdit && prodEdgeNetworkDeployed }"  (click)="selectSecondary(option.value)">
                <mat-icon [svgIcon]="(option.value === 'true' ? 'radio_button_checked' : 'radio_button_unchecked')" class="radio-icon cursor-pointer icon-md-1 mr-4" [ngClass]="{ 'disabled': isEdit && prodEdgeNetworkDeployed }"></mat-icon>
                {{option.label | titlecase}}
                </div>
              </div>
              </div>
          </ng-container>
         </div>
        </div>
    </div>

    <!--Customer Information step 3-->
    <div [formGroup]="custInfoForm" *ngIf="currentStep === 3" class="environment_header min-h-[400px] mt-24">
        <div class="flex flex-row ml-24 mr-24 mt-24">
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.CUSTOMER_NAME' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CUSTOMER_NAME' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <input formControlName="customerName" class="blend-border mt-4 blueprint-name" [ngClass]="{ 'input-disabled': isEdit }"
                [placeholder]="'TENANT_FORM.ENTER_CUSTOMER_NAME' | transloco">
                  <app-error [control]="custInfoForm?.get('customerName')"></app-error>
            </div>
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.CUSTOMER_NUMBER' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CUSTOMER_NUMBER' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <input formControlName="customerNumber" class="blend-border mt-4 blueprint-name" [ngClass]="{ 'input-disabled': isEdit }"
                [placeholder]="'TENANT_FORM.ENTER_CUSTOMER_NUMBER' | transloco">
                  <app-error [control]="custInfoForm?.get('customerNumber')"></app-error>
            </div>
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.CUSTOMER_REGION' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CUSTOMER_REGION' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <input formControlName="customerRegion" class="blend-border mt-4 blueprint-name" [ngClass]="{ 'input-disabled': isEdit }"
                [placeholder]="'TENANT_FORM.ENTER_CUSTOMER_REGION' | transloco">
                  <app-error [control]="custInfoForm?.get('customerRegion')"></app-error>
            </div>
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.COUNTRY' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.COUNTRY' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <input formControlName="customerCountry" class="blend-border mt-4 blueprint-name" [ngClass]="{ 'input-disabled': isEdit }"
                [placeholder]="'TENANT_FORM.ENTER_CUSTOMER_COUNTRY' | transloco">
                  <app-error [control]="custInfoForm?.get('customerCountry')"></app-error>
            </div>
        </div>
        <div class="flex flex-row mr-24 ml-24 mt-24">
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.MNEMONIC' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.MNEMONIC' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <input formControlName="customerMnemonic" class="blend-border mt-4 blueprint-name"
                [placeholder]="'TENANT_FORM.ENTER_MNEMONIC' | transloco">
                  <app-error [control]="custInfoForm?.get('customerMnemonic')"></app-error>
            </div>
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.CUSTOMER_SCORECARD' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CUSTOMER_SCORECARD' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <mat-select formControlName="scoreCard" [ngClass]="{ 'input-disabled': isEdit }" class="blend-border drop-down mt-4 pt-4" [placeholder]="'TENANT_FORM.CHOOSE_CUSTOMER_SCORECARD' | transloco">
                    <mat-option *ngFor="let scorecard of scorecards" [value]="scorecard">{{ scorecard }}</mat-option>
                </mat-select>
                <app-error [control]="custInfoForm.get('scoreCard')"></app-error>
            </div>
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                  <label class="schedule-spacing fw-700 fs-12">{{ 'TENANT_FORM.CUSTOMER_SALESCHANNEL' | transloco | uppercase }}</label>
                  <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CUSTOMER_SALESCHANNEL' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <mat-select formControlName="salesChannel" [ngClass]="{ 'input-disabled': isEdit }" class="blend-border drop-down mt-4 pt-4" [placeholder]="'TENANT_FORM.ENTER_CUSTOMER_SALESCHANNEL' | transloco">
                    <mat-option *ngFor="let salesChannel of saleschannels" [value]="salesChannel">{{ salesChannel }}</mat-option>
                </mat-select>
                  <app-error [control]="custInfoForm?.get('salesChannel')"></app-error>
            </div>
            <div class="flex flex-col form-field name-field ml-24">
                <div class="flex flex-row flex-wrap">
                    <label class="schedule-spacing fw-700 fs-12">{{'TENANT_FORM.CONTRACT_END_DATE' | transloco | uppercase}}</label>
                    <mat-icon class="icon-sm ml-8" [matTooltip]="'TENANT_FORM.CONTRACT_END_DATE' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                </div>
                <div class="date-picker mt-4">
                    <app-datepicker [control]="custInfoForm.get('contractEndDate')" [placeholder]="'TENANT_FORM.SELECT_CONTRACT_END_DATE' | transloco" (dateChange)="contractEndDateChange($event)" class="datepicker" [min]="minDate"></app-datepicker>
                    <app-error [control]="custInfoForm.get('contractEndDate')"></app-error>
                </div>
            </div>
        </div>
    </div>


    <!--Features step 4-->
<div *ngIf="currentStep === 4"  [formGroup]="featuresForm" class="mt-24">
<div  formArrayName="features" class="environment_header feature-tenant">
<div class="flex flex-row add-tenant">
    <div  class="flex flex-row w-75-percent">
    <div class="flex flex-col form-field feature-field name-field ml-24 mt-24">
    <span class="schedule-spacing mat-subtitle-2 fw-700  mr-40 items-center justify-center">{{'ADD_TENANT.FEATURES' | transloco}}</span>
    </div>
    <div class="flex flex-col ml-40 mr-20 mt-24">
    <span class="schedule-spacing mat-subtitle-2 fw-700  mb-22 items-center justify-center">{{'TENANT_LIST.NON_PII_SMALL' | transloco}}</span>
    </div>
    <div class="flex flex-col ml-40 mr-40 mt-24">
      <span class="schedule-spacing mat-subtitle-2 fw-700  mb-22 items-center justify-center">{{'TENANT_LIST.PII' | transloco}}</span>
      </div>
    <div class="flex flex-col ml-40 mr-20 mt-24">
    <span class="schedule-spacing mat-subtitle-2 fw-700  mb-22 items-center justify-center">{{'TENANT_LIST.PROD' | transloco}}</span>
    </div>
</div>
<div class="flex  w-25-percent justify-end mr-16 items-center">
  <button class="flex white h-32 justify-end fs-16 fw-500 items-center" type="button" (click)="resetFeature()">
    <mat-icon svgIcon="refresh" class="mr-12" [@rotate]="count"
    (@rotate.done)="isLoading && count=count+1"></mat-icon>
    {{'ADD_TENANT.RESET_TO_DEFAULT' | transloco}}</button>
  </div>
</div>


<div class="environment_header">
    <div class="w-70-percent height-additional">
      <ng-container *ngFor="let feature of features.controls; let i = index; let last = last">
        <div [formGroupName]="i" class="flex flex-row mt-12 items-center"   [class.disabled-row]="!feature.get('modifiable')?.value">

          <div class="flex flex-col form-field feature-field name-field ml-24">
            <div class="flex flex-row items-center">
              <mat-icon  (click)="toggleDefaultEnabled(feature)" [svgIcon]="feature.get('defaultEnabled')?.value ? 'check_box' : 'check_box_outline_blank'"
              class="checkbox icon-md-1 mr-8" [ngClass]="{ 'disabled-row': !feature.get('modifiable')?.value }">
              </mat-icon>
              <span class="mat-subtitle-2 fw-500 name-field  items-center justify-center">{{ feature.get('name')?.value }}</span>
              <div class="ml-6 mr-10 inline-block relative">
                <mat-icon class="icon-sm ml-4 mt-4 cursor-pointer info-icon" svgIcon="info"
                  (click)="openTooltip(i, feature)"></mat-icon>
                <div *ngIf="tooltipVisible && activeTooltipIndex === i" class="cert-tooltip p-16 custom-tooltip">
                  <div class="flex justify-end">
                    <mat-icon class="w-16 h-16 mr-0 cursor-pointer" svgIcon="close"
                      (click)="tooltipVisible = false"></mat-icon>
                  </div>
                  <div class="fs-16 fw-500 mat-body-2 mb-10 mt-8">
                    {{ tooltipData?.description || '--' }}
                  </div>
                  <div class="flex items-center cursor-pointer mt-5">
                    <mat-icon svgIcon="open_in_new" class="mr-6" (click)="openUrl()"></mat-icon>
                    <span class="underline fw-500 underline-offset" (click)="openUrl()">{{ 'TENANT_LIST.KNOW_MORE' | transloco }}</span>
                  </div>
                  <div class="tooltip-arrow"></div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="feature.get('defaultEnabled')?.value" class="flex flex-col ml-40 mr-20 mb-22">
            <mat-slide-toggle formControlName="nonpii"></mat-slide-toggle>
          </div>
          <div *ngIf="feature.get('defaultEnabled')?.value" class="flex flex-col  ml-30 mr-20 mb-22">
            <mat-slide-toggle formControlName="pii"></mat-slide-toggle>
          </div>
          <div *ngIf="feature.get('defaultEnabled')?.value" class="flex flex-col ml-30 mr-20 mb-22">
            <mat-slide-toggle formControlName="prod"></mat-slide-toggle>
          </div>
        </div>
        <mat-divider *ngIf="!last" class="ml-24 mr-24 divider"></mat-divider>

      </ng-container>

    </div>
  </div>



</div>
</div>

    <!--Settings step 5-->
    <div [formGroup]="settingsForm" *ngIf="currentStep === 5" class="environment_header mt-24">
        <div class="flex flex-row ml-24 mt-24">
          <div class="flex flex-col form-field-email name-field ml-24 mr-30">
            <div class="flex flex-col mat-subtitle-2 ml--16">
                    <div class="flex flex-row">
                        <label class="fw-700 fs-12" >{{'TENANT_LIST.ADD_EMAIL_ADDRESS' | transloco | uppercase}}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-8 mb-4" matTooltipClass="form-tooltip right" [matTooltip]="'TENANT_FORM.ADD_EMAIL_ADDRESS' | transloco"
                        matTooltipPosition="right"></mat-icon>
                    </div>
                    <mat-form-field class="email-list w-full">
                        <mat-chip-grid #chipGrid aria-label="Email Address">
                            <mat-chip-row *ngFor="let email of emailNotifications"
                            (removed)="remove(email)" [ngClass]="{'invalid-email': !isValidEmail(email)}">
                            {{email}}
                            <button matChipRemove>
                                <mat-icon svgIcon="close"></mat-icon>
                            </button>
                            </mat-chip-row>
                            <input placeholder="{{'TENANT_LIST.EMAIL_ADDRESS' | transloco}}"
                                [matChipInputFor]="chipGrid"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="addOnBlur"
                                (matChipInputTokenEnd)="add($event)"
                                />
                        </mat-chip-grid>
                    </mat-form-field>
                    <span *ngIf="emails?.length > limit" class="max-limit mt--24 fs-12">{{'TENANT_FORM.ALLOW_MAX_EMAIL_ADDRESS' | transloco: {limit: limit} }}</span>
                    <span *ngIf="invalidEmail && invalidEmail?.length !== 0 && emails?.length <= limit" class="max-limit mt--24 fs-12">{{'TENANT_FORM.ENTER_VALID_EMAIL' | transloco}}</span>
                </div>
            </div>
        </div>


    </div>

        <!--Summary step 6-->
        <div *ngIf="currentStep === 6" class="mt-24">
            <!--summarize step 1 -->
            <div class="flex flex-col p-24 environment_header mb-16">
                <div class="flex flex-row">
                  <div class="basis-full heading fs-16 fw-700 mb-16">{{ 'ADD_TENANT.FOUNDATION_DETAILS' | transloco }}</div>
                  <div class="flex justify-end cursor-pointer edit-border" (click)="goToStep(1)">
                    <mat-icon svgIcon="edit" class="icon-sm mr-4 edit-design"></mat-icon>
                    <div class="flex items-center fs-20 fs-16 fw-500">{{ 'BUTTONS.EDIT' | transloco | titlecase}}</div>
                  </div>
                </div>
                <div class="flex flex-row w-80-percent justify-between">
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.REALM_NAME' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ this.detailsForm.get('tenantId').value }}</div>
                  </div>
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.IT_TICKETNUMBER' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ this.detailsForm.get('ticketNumber').value }}</div>
                  </div>
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.CUSTOMER_STATUS' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ this.detailsForm.get('status').value }}</div>
                  </div>
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.TENANT_OWNER' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ this.detailsForm.get('tenantOwner').value }}</div>
                  </div>
                </div>
            </div>
            <!--summarize step 2 -->
            <div class="flex flex-col p-24 environment_header mb-16">
                <div class="flex flex-row">
                  <div class="basis-full heading fs-16 fw-700 mb-16">{{ 'ADD_TENANT.CLOUD_REGION' | transloco }}</div>
                  <div class="flex justify-end cursor-pointer edit-border" (click)="goToStep(2)">
                    <mat-icon svgIcon="edit" class="icon-sm mr-4 edit-design"></mat-icon>
                    <div class="flex items-center fs-20 fs-16 fw-500">{{ 'BUTTONS.EDIT' | transloco | titlecase}}</div>
                  </div>
                </div>
                <div class="flex flex-row w-80-percent justify-between">
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'INSTRUCTION.CREATE_INSTRUCTION.CLOUD_PROVIDER' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ cloudRegionForm?.get('cloudProvider').value }}</div>
                  </div>
                  <div *ngIf="isRegionPairSelected" class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.TEMENOS_REGION' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{selectedRegion.value }} | {{ cloudRegionForm?.get('regionPair').value }}</div>
                  </div>
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'INSTRUCTION.CREATE_INSTRUCTION.PRIMARY_REGION' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ cloudRegionForm?.get('primaryRegion').value }}</div>
                  </div>
                  <div *ngIf="!singleRegionSelected" class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'INSTRUCTION.CREATE_INSTRUCTION.SECONDARY_REGION' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ cloudRegionForm?.get('secondaryRegion').value }}</div>
                  </div>
                </div>
                <div class="flex flex-col service-title mt-8">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.SECONDARY_DEPLOYMENT' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{selectedSecondary }}</div>
                </div>
            </div>

             <!--summarize step 3 -->
             <div class="flex flex-col p-24 environment_header mb-16">
                <div class="flex flex-row">
                  <div class="basis-full heading fs-16 fw-700 mb-16">{{ 'ADD_TENANT.CUSTOMER_INFORMATION' | transloco }}</div>
                  <div class="flex justify-end cursor-pointer edit-border" (click)="goToStep(3)">
                    <mat-icon svgIcon="edit" class="icon-sm mr-4 edit-design"></mat-icon>
                    <div class="flex items-center fs-20 fs-16 fw-500">{{ 'BUTTONS.EDIT' | transloco | titlecase}}</div>
                  </div>
                </div>
                <div class="flex flex-row w-80-percent justify-between">
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.CUSTOMER_NAME' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ custInfoForm?.get('customerName').value }}</div>

                    <div class="overline-font subheading fs-14 fw-700 mb-8 mt-8">{{ 'TENANT_FORM.MNEMONIC' | transloco | uppercase }}</div>
                    <div *ngIf="custInfoForm?.get('customerMnemonic').value; else dash " class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ custInfoForm?.get('customerMnemonic').value }}</div>
                  </div>
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.CUSTOMER_NUMBER' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{custInfoForm?.get('customerNumber').value }}</div>

                    <div class="overline-font subheading fs-14 fw-700 mb-8 mt-8">{{ 'TENANT_FORM.CUSTOMER_SCORECARD' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{custInfoForm?.get('scoreCard').value }}</div>
                  </div>
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.CUSTOMER_REGION' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ custInfoForm?.get('customerRegion').value }}</div>

                    <div class="overline-font subheading fs-14 fw-700 mb-8 mt-8">{{ 'TENANT_FORM.CUSTOMER_SALESCHANNEL' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ custInfoForm?.get('salesChannel').value }}</div>
                  </div>
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_FORM.COUNTRY' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{custInfoForm?.get('customerCountry').value }}</div>

                    <div class="overline-font subheading fs-14 fw-700 mb-8 mt-8">{{ 'TENANT_FORM.CONTRACT_END_DATE' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{custInfoForm?.get('contractEndDate').value  | date: 'MMM d, y' }}</div>
                  </div>
                  </div>
            </div>


            <!--summarize step 4 -->
            <div class="flex flex-col p-24 environment_header mb-12">
              <div class="flex flex-row justify-between items-center">
                  <div class="flex flex-col ml-12">
                  <span class="schedule-spacing basis-full mat-subtitle-2 fw-700  mr-40 items-center justify-center">Features</span>
                  </div>
                  <div class="flex flex-col mr-40">
                    <span class="schedule-spacing mat-subtitle-2 fw-700 mr-10 items-center justify-center">{{'TENANT_LIST.NON_PII_SMALL' | transloco}}</span>
                  </div>
                  <div class="flex flex-col mr-40">
                  <span class="schedule-spacing mat-subtitle-2 fw-700 mr-10 items-center justify-center">{{'TENANT_LIST.PII' | transloco}}</span>
                  </div>
                  <div class="flex flex-col mr-40">
                  <span class="schedule-spacing mat-subtitle-2 fw-700 mr-10 items-center justify-center">{{'TENANT_LIST.PROD' | transloco}}</span>
                  </div>
                 <div class="flex flex-row cursor-pointer edit-border" (click)="goToStep(4)">
                    <mat-icon svgIcon="edit" class="icon-sm mr-4 edit-design"></mat-icon>
                    <div class="flex items-center fs-20 fs-16 fw-500">{{ 'BUTTONS.EDIT' | transloco | titlecase}}</div>
                  </div>
              </div>
                <mat-divider  class="ml-12 mr-12 divider-color mb-12 mt-12"></mat-divider>

                <ng-container *ngFor="let feature of features.controls; let last = last" class="flex flex-row">
                  <div *ngIf="feature.get('defaultEnabled')?.value" class="flex flex-row">
                    <div class="flex flex-col form-field feature-field name-field ml-12">
                    <span class="schedule-spacing mat-subtitle-2 fw-700  mr-40 items-center justify-center">{{ feature.get('name')?.value }}</span>
                    </div>
                    <div class="flex flex-col form-field feature-field name-field ml-40">
                      <span *ngIf="feature.get('nonpii')?.value;" class="schedule-spacing mat-subtitle-2 fw-700 fs-14 feature-circle flex items-center justify-center">
                        <mat-icon  *ngIf="feature.get('nonpii')?.value" svgIcon="done" class="color-done"></mat-icon>
                      </span>
                      <span *ngIf="(!feature.get('nonpii')?.value && !feature.get('nonpii')?.disabled)" class="schedule-spacing mat-subtitle-2 fw-700 fs-14 failed flex items-center justify-center">
                        <mat-icon  *ngIf="(!feature.get('nonpii')?.value && !feature.get('nonpii')?.disabled)" svgIcon="close" class="color-done"></mat-icon>
                      </span>
                      <span *ngIf="(!feature.get('nonpii')?.value && feature.get('nonpii')?.disabled)">-</span>
                    </div>
                    <div class="flex flex-col form-field feature-field name-field ml-40">
                      <span *ngIf="feature.get('pii')?.value" class="schedule-spacing mat-subtitle-2 fw-700 fs-14 feature-circle flex items-center justify-center">
                        <mat-icon  *ngIf="feature.get('pii')?.value" svgIcon="done" class="color-done"></mat-icon>
                      </span>
                      <span *ngIf="(!feature.get('pii')?.value && !feature.get('pii')?.disabled)" class="schedule-spacing mat-subtitle-2 fw-700 fs-14 failed flex items-center justify-center">
                        <mat-icon  *ngIf="(!feature.get('pii')?.value && !feature.get('pii')?.disabled)" svgIcon="close" class="color-done"></mat-icon>
                      </span>
                      <span *ngIf="(!feature.get('pii')?.value && feature.get('pii')?.disabled)">-</span>
                    </div>
                    <div class="flex flex-col form-field feature-field name-field ml-20">
                      <span *ngIf="feature.get('prod')?.value" class="schedule-spacing mat-subtitle-2 fw-700 fs-14 feature-circle flex items-center justify-center">
                        <mat-icon  *ngIf="feature.get('prod')?.value" svgIcon="done" class="color-done"></mat-icon>
                      </span>
                      <span *ngIf="(!feature.get('prod')?.value && !feature.get('prod')?.disabled)" class="schedule-spacing mat-subtitle-2 fw-700 fs-14 failed flex items-center justify-center">
                        <mat-icon  *ngIf="(!feature.get('prod')?.value && !feature.get('prod')?.disabled)" svgIcon="close" class="color-done"></mat-icon>
                      </span>
                      <span *ngIf="(!feature.get('prod')?.value && feature.get('prod')?.disabled)">-</span>
                    </div>
                  </div>
                    <mat-divider *ngIf="!last && feature.get('defaultEnabled')?.value" class="divider-color-feature ml-12 mr-12 mb-12"></mat-divider>
                </ng-container>
            </div>


            <!--summarize step 5 -->
          <div class="flex flex-col p-24 environment_header mb-16">
            <div class="flex flex-row">
              <div class="basis-full heading fs-16 fw-700 mb-16">{{ 'ADD_TENANT.SETTINGS' | transloco }}</div>
              <div class="flex justify-end cursor-pointer edit-border" (click)="goToStep(5)">
                <mat-icon svgIcon="edit" class="icon-sm mr-4 edit-design"></mat-icon>
                <div class="flex items-center fs-20 fs-16 fw-500">{{ 'BUTTONS.EDIT' | transloco | titlecase}}</div>
              </div>
            </div>
            <div class="flex flex-row">
            <div class="w-50-percent justify-between">
              <div class="flex flex-row service-title">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TENANT_LIST.ADD_EMAIL_ADDRESS' | transloco | uppercase }}</div>
              </div>
              <div *ngIf="emailNotifications.length > 0; else dash" class="flex flex-row flex-wrap service-title">
                <div *ngFor="let email of emailNotifications; let last = last" class="flex flex-row">
                <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word"><label>{{email | trim}}</label>
                  <span *ngIf="!last" class="pr-1">, </span>
                </div>
              </div>
              </div>
            </div>
            </div>
          </div>

          <ng-template #dash>
            <span>-</span>
          </ng-template>
        </div>


    <div class="summary-header mt-24 items-center justify-between" [ngClass]="currentStep === 4 ? 'flex flex-row':''">
        <div *ngIf="currentStep === 4" class="feature-note">{{'TENANT_LIST.FEATURES_NOTE' | transloco}}</div>
        <div class="flex flex-row justify-end items-center">
          <div class="flex items-center">
            <ng-container *ngIf="currentStep !== 1" class="flex flex-row">
                <mat-icon svgIcon="arrow_back" class="icon-sm cursor-pointer mr-8" (click)="goToStep(currentStep - 1, undefined, true)"></mat-icon>
                <div class="mat-subtitle-2 fw-700 mb-0 cursor-pointer" (click)="goToStep(currentStep - 1, undefined, true)">
                {{ 'BUTTONS.PREVIOUS' | transloco }}
                </div>
            </ng-container>
            <button class="white ml-40" (click)="cancelTenant()">
              {{ 'BUTTONS.CANCEL' | transloco }}
            </button>
          </div>
          <div class="flex">
            <button
              *ngIf="currentStep !== stepsArray.length"
              class="accent ml-24 cursor-pointer" type="button"
              (click)="goToStep(currentStep + 1, currentStep)"
              [ngClass]="{'disabled': currentStep === 5 && !isAllEmailsValid()}">{{ 'BUTTONS.NEXT' | transloco }}

            </button>
            <button
              *ngIf="currentStep === stepsArray.length"
              class="accent ml-24" type="button"
              (click)=" isEdit ? editTenant() : createTenant()">{{ isEdit ? ('BUTTONS.SUBMIT' | transloco) : ('BUTTONS.CREATE' | transloco) }}
            </button>
          </div>
        </div>
      </div>
</div>
